<template>
    <b-overlay :show="loading">

        <div class="div-section-body">
            <div v-for="(row,ix) in drilldowns" v-bind:key="ix" class="mt-2 mb-2">

                <b-row class="mt-2 mb-4">
                    <b-col cols="12" v-if="(ix==1)">
                      <h5 class="mb-3">More 5-Minute Drill Down Videos</h5>
                    </b-col>
                    <b-col cols="12">

                        <vue-plyr :ref="'plyr'+ix" :key="ix" :options="{ controls: ['play', 'progress', 'volume'] }" class="pr-2">
                            <div class="yt-container">
                                <!-- https://developers.google.com/youtube/iframe_api_reference -->
                                <iframe
                                :src="getVideoUrl(row.youtubeUrl, ix)"
                                allowfullscreen allowtransparency>
                                </iframe>
                            </div>
                        </vue-plyr>
                    </b-col>
                    <b-col cols="12" class="mt-2">
                    <div class="class-title dd-title">
                        <b-icon icon="caret-right-fill"></b-icon> {{ row.title }}
                        <!-- {{row.slug}} -->
                    </div>
                    </b-col>
                </b-row>
            </div>
        </div>
    </b-overlay>
</template>

<script>
'use strict'
/* eslint-disable */

import service from "@/service/service"
import utils from "@/utils/utils"

export default {
  name: "LobbyDrilldowns",
  data() {
    return {
      debug: false,
      error: false,
      errorMsg: null,
      busy: false,
      success: false,
      loading: true,
      classHash: null,
      studentHash: null,
      drilldowns: [],
      playerCounter: 0,
      playerTimer: null,
      currentPlayerIx: -1
    }
  },
  props: {
    ch: {  // class hash
      type: String,
      default: null
    },
    sh: {  // student hash object
      type: String,
      default: null
    },
    darr: {     // array of drilldown objects
        type: Array,
        default: []
    }
  },
  computed: {
  },
  methods: {
    getVideoUrl(youtubeUrl, ix) {
      let code = utils.getYoutubeCode(youtubeUrl)
      let url = utils.getYoutubeUrl(code, (ix == 0))   // Autoplay on first item.
      return url
    },
    clearPlayerTimer() {
      // if defined clear timer to get the vue plyr.
      if (this.playerTimer) window.clearInterval(this.playerTimer)
      this.playerTimer = null
    },
    playerEvents () { // load player events
        // if (!this.$refs.plyr0) {   // also works
        if (!this.$refs['plyr0']) {
            this.playerCounter++
            if (this.playerCounter > 40) {
                this.clearPlayerTimer()
                this.bail('Timed out loading video.')   // TBD
            }
            if (this.debug) console.log(`${this.playerCounter}) NO PLAYER`)
            if (!this.playerTimer) {
                // Takes about 3 seconds for plyr to appear in $refs.
                this.playerTimer = window.setInterval( (function () { this.playerEvents() }).bind(this), 300 )
            }
            return
        }
        else {
            if (this.debug) console.log(`${this.playerCounter}) PLAYER FOUND`)
            this.clearPlayerTimer()
        }

        for (let ix=0; ix < this.drilldowns.length; ix++) {
            // const player = this.$refs['plyr'.concat(ix)].player
            const player = this.$refs['plyr'.concat(ix)][0].player
            if (this.debug) console.log(`Plyr ${ix}:`, player)
            if (player) {
                if (this.debug) console.log(`Plyr ${ix} events: ${this.drilldowns[ix].hash}`)
                player.on('statechange', ((e) => {
                    // e.detail.code
                    // -1 – unstarted
                    // 0 – ended   YT.PlayerState.ENDED
                    // 1 – playing  YT.PlayerState.PLAYING
                    // 2 – paused  YT.PlayerState.PAUSED
                    // 3 – buffering  YT.PlayerState.BUFFERING
                    // 5 – video cued  YT.PlayerState.CUED   (not issued)
                    if (this.debug) console.log(`Youtube event code: ${e.detail.code}`)
                    switch (e.detail.code) {
                        case YT.PlayerState.PLAYING:
                            // Turn off other playing video.
                            if (this.currentPlayerIx >= 0 && this.currentPlayerIx != ix) {
                                let p = this.$refs['plyr'.concat(this.currentPlayerIx)][0].player
                                if (p) {
                                    p.pause()
                                    this.currentPlayerIx = ix
                                }
                            }
                            this.currentPlayerIx = ix
                            if (this.debug) console.log(`Log Play: ${this.drilldowns[ix].hash}`)
                            this.logPlay(this.drilldowns[ix].hash, this.studentHash )
                            break
                    }
                }).bind(this))
            }
            else {
                if (this.debug) console.log(`Plyr ${ix} NOT FOUND:`, player)
            }
        }
    },
    logPlay(drilldownHash, studentHash) {
      if (this.debug) console.log(`logPlay ${drilldownHash}`)
      service
        .drilldownView(drilldownHash, studentHash)
        .then(
          (res => {
            if (this.debug) console.log(res)
            if (res.status) {
              // not much to do...?
            }
            else {
              this.error = true
              this.errorMsg = 'Error logging drilldown play.'
            }
          }).bind(this)
        )
        .finally(e => {
          if (this.debug) console.log(`finally...`)
        })
        .catch(e => {
          this.error = true
          this.errorMsg = 'System error. Logging API failure.'
          console.log(e)
        })
    },
    bail(msg) {
      this.error = true
      this.errorMsg = msg
    }
  },
  created() {
    this.loading = true
    this.drilldowns = this.darr || []
    this.classHash = this.ch || {}
    this.studentHash = this.sh || {}
    if (this.debug) console.log('studentHash', this.studentHash)
    this.loading = false
    this.currentPlayerIx = -1   // Index of current playing drilldown
  },
  mounted() {
    if (this.debug) console.log('mounted LobbyDrilldowns')
    this.playerEvents()
  },
  destroy() {
  }
}
</script>

<style scoped>

.yt-container {
  position:relative;
  padding-bottom:56.25%;
  padding-top:30px;
  height:0;
  overflow:hidden;
  border: 2px solid green;
  width:100% !important;
  width:95% !important;
  height:100% !important;
}
.yt-container iframe, .yt-container object, .yt-container embed {
  position:absolute;
  top:0;
  left:0;
  border: 1px solid red;
  width:100% !important;
  height:100% !important;
}

.dd-featured {
    background-color: #F5F5F5;
    border-radius: 8px;
    padding: .1rem;
}

.dd-title {
    color: #014767 !important;
}

</style>



// WEBPACK FOOTER //
// src/components/LobbyDrilldowns.vue